import { ResponseType } from 'axios'

export interface NetworkConfig {
  /**
   * Base URL of the server
   */
  baseUrl?: string

  /**
   * common request time out for given server
   */
  timeOut?: number

  /**
   * common headers for all the requests associated with the config
   */
  headers?: { [key: string]: string }

  /**
   * common retryCount for all the requests associated with the config
   */
  retryCount?: number

  responseType?: ResponseType
  abortController?: AbortController
}

const config: { [key: string]: NetworkConfig } = {
  default: {
    timeOut: 60000,
    headers: {
      'Content-Type': 'application/json',
    },
    retryCount: 0,
  },
  generic: {
    timeOut: 60000,
    headers: {
      'Content-Type': 'application/json',
    },
    retryCount: 0,
  },
  oms: {
    timeOut: 60000,
    headers: {
      'Content-Type': 'application/json',
    },
    retryCount: 0,
  },
  test: {
    timeOut: 60000,
    headers: {
      'Content-Type': 'application/json',
    },
    retryCount: 0,
  },
}

export default config
